__turbopack_context__.v({
  "amount": "OrderDetails-module-scss-module__DqlOBq__amount",
  "calculated": "OrderDetails-module-scss-module__DqlOBq__calculated",
  "discount": "OrderDetails-module-scss-module__DqlOBq__discount",
  "free": "OrderDetails-module-scss-module__DqlOBq__free",
  "image": "OrderDetails-module-scss-module__DqlOBq__image",
  "imagePlaceholder": "OrderDetails-module-scss-module__DqlOBq__imagePlaceholder",
  "item": "OrderDetails-module-scss-module__DqlOBq__item",
  "itemImage": "OrderDetails-module-scss-module__DqlOBq__itemImage",
  "itemInfo": "OrderDetails-module-scss-module__DqlOBq__itemInfo",
  "itemName": "OrderDetails-module-scss-module__DqlOBq__itemName",
  "itemSku": "OrderDetails-module-scss-module__DqlOBq__itemSku",
  "items": "OrderDetails-module-scss-module__DqlOBq__items",
  "lineError": "OrderDetails-module-scss-module__DqlOBq__lineError",
  "preOrderBreakdown": "OrderDetails-module-scss-module__DqlOBq__preOrderBreakdown",
  "row": "OrderDetails-module-scss-module__DqlOBq__row",
  "totals": "OrderDetails-module-scss-module__DqlOBq__totals",
  "wrapper": "OrderDetails-module-scss-module__DqlOBq__wrapper",
});
